import { type FC } from "react";
import clsx from "clsx";
import Modal from "../Common/Modal";
import { buttonBase } from "../Common/FormStyle";

interface ConfirmModal {
  texts: {
    modalHead: string;
    head: string;
    desc?: string;
    okText?: string;
  };
  closeModal: () => void;
  onOk: () => void;
}

const ConfirmModal: FC<ConfirmModal> = ({
  texts = {
    modalHead: "",
    head: "",
    desc: "",
    okText: "削除する",
  },

  closeModal,
  onOk,
}) => {
  return (
    <Modal
      title={texts.modalHead}
      onDismiss={() => {
        closeModal();
      }}
    >
      <div className="modal">
        <div className="modal-content">
          <div
            className={clsx(
              "flex",
              "justify-center",
            )}
          >
            <div
              className={clsx(
                "max-w-[90%]",
                "flex",
                "flex-col",
                "gap-10",
                "py-30",
              )}
            >
              <div
                className={clsx(
                  "text-center",
                  "text-16",
                  "whitespace-pre-wrap",
                  "leading-[1.8]",
                )}
              >
                {texts.head}
              </div>
              {texts.desc && (
                <div
                  className={clsx(
                    "text-13",
                    "text-gray-400",
                    "text-center",
                    "whitespace-pre-wrap",
                    "leading-[1.8]",
                  )}
                >
                  {texts.desc}
                </div>
              )}
            </div>
          </div>
          <div
            className={clsx(
              "py-20",
              "text-center",
              "border-gray-100",
              "border",
              "flex",
              "gap-20",
              "justify-center",
            )}
          >
            <button
              onClick={() => {
                closeModal();
              }}
              className={clsx(
                buttonBase({
                  variant: "ol",
                }),
              )}
            >
              キャンセル
            </button>
            <button
              onClick={() => {
                onOk();
              }}
              className={clsx(
                buttonBase({
                  variant: "red",
                }),
              )}
            >
              {texts.okText ?? "削除する"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
